import React from 'react'
import { Field } from 'redux-form'
import { Alert } from 'antd'
import { InputField, CheckboxField } from 'FormFields'

const labelColSpan = 6
const wrapperColSpan = 14

type Props = {
  submitting: boolean,
    forcingReset?: boolean,
}

export default class extends React.PureComponent<Props> {

  render() {

    const {
      submitting,
        forcingReset,
    } = this.props

    return (

      <div>

        {forcingReset && (
          <Alert
            message=""
            description="You must update your password before using the system."
            type="warning"
            showIcon
            style={{ marginBottom: '20px' }}
          />
        )}

        <Field
          component={InputField}
          name='password'
          label='Password'
          type='password'
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          component={InputField}
          name='password_confirm'
          label='Confirm'
          type='password'
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        {!forcingReset && (
          <div>
            <div style={{ marginLeft: `${(labelColSpan / 24) * 100}%` }}>
              <Field
                component={CheckboxField}
                name='force_reset_on_login'
                text='Force reset'
                disabled={submitting}
              />
            </div>

            <div style={{ marginLeft: `${(labelColSpan / 24) * 100}%`, color: '#666', fontSize: '12px' }}>
              When checked, the user will be required to change their password on their next login.
            </div>
          </div>
        )}

      </div>

    )

  }

}
